







































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IWorkflowForSelection,
  IWorkflowProjectForSelection,
} from '@/api/types/response.types'
import {
  IConvosInputBulkEditMailbox,
  IStatusMapping,
  ITasksInputBulkEditInternalProject,
} from '@/api/types/request.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'
import TasksAPI from '@/api/modules/tasks.api'
import ConversationsAPI from '@/api/modules/convos.api'

export default Vue.extend({
  name: 'BulkMoveItemsModal',
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    selectedItemIds: {
      type: Array as () => number[],
      default: (): number[] => [],
    },
    isConvoRelated: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      TextAssistant,
      ColorAssistant,
      EEntities,
      isLoading: false,
      isSubmitting: false,
      comment: '',

      // Projects
      workflowID: 0,
      entities: [] as IWorkflowProjectForSelection[],
      workflows: [] as IWorkflowForSelection[],
      selectedEntityID: null,
      requiresStatusMapping: false,
      statusMappings: [] as IStatusMapping[],
    }
  },
  computed: {
    entityType(): EEntities {
      return this.isConvoRelated ? EEntities.MAILBOXES : EEntities.PROJECTS
    },
    title(): string {
      return `Move to another ${TextAssistant.entitySingularName(
        this.entityType,
      ).toLowerCase()}`
    },
    subTitle(): string {
      if (this.selectedItemIds.length > 1) {
        return `Anyone assigned to these ${TextAssistant.itemPluralName(
          this.entityType,
        ).toLowerCase()} will be notified of your change.`
      } else {
        return `Anyone assigned to this ${TextAssistant.itemSingularName(
          this.entityType,
        ).toLowerCase()} will be notified of your change.`
      }
    },
    disableSubmit(): boolean {
      return (
        this.selectedEntityID === null ||
        (this.requiresStatusMapping && !this.allStatusesMapped)
      )
    },
    currentWorkflow(): IWorkflowForSelection {
      return this.workflows.find(w => w.id === this.workflowID)
    },
    newWorkflow(): IWorkflowForSelection {
      const newWorkflowID = this.entities.find(
        p => p.id === this.selectedEntityID,
      ).workflowID
      return this.workflows.find(w => w.id === newWorkflowID)
    },
    allStatusesMapped(): boolean {
      return (
        this.statusMappings.length > 0 &&
        this.statusMappings.filter(m => m.newStatusID === null).length === 0
      )
    },
  },
  watch: {
    selectedEntityID: {
      immediate: false,
      handler(val: Number) {
        const sameWorkflow =
          this.entities.find(p => p.id === val).workflowID === this.workflowID
        this.requiresStatusMapping = !sameWorkflow
      },
    },
  },
  async created() {
    this.isLoading = true
    await this.loadInitialState()
    this.isLoading = false
  },
  methods: {
    getEntityIcon(entity: IWorkflowProjectForSelection) {
      if (entity.isFavorite) {
        return 'star-filled'
      }
      return this.entityType === EEntities.MAILBOXES ? 'mailbox' : 'project'
    },
    async loadInitialState() {
      if (this.isConvoRelated) {
        this.workflows = await MailboxesAPI.get_Workflows()
        const updatableInternalProjectsInfo = await MailboxesAPI.get_UpdatableMailboxes(
          this.entityId,
        )
        this.workflowID = updatableInternalProjectsInfo.workflowID
        this.entities = updatableInternalProjectsInfo.listMailboxes
      } else {
        this.workflows = await InternalProjectsAPI.get_Workflows()
        const updatableInternalProjectsInfo = await InternalProjectsAPI.get_UpdatableInternalProjects(
          this.entityId,
        )
        this.workflowID = updatableInternalProjectsInfo.workflowID
        this.entities = updatableInternalProjectsInfo.listInternalProjects
      }
      return
    },
    async handleUpdate() {
      this.isSubmitting = true
      let submitSucceeded = false

      if (this.isConvoRelated) {
        const data = {
          listConversationIDs: this.selectedItemIds,
          newMailboxID: this.selectedEntityID,
          listStatusMappings: this.statusMappings,
        } as IConvosInputBulkEditMailbox
        try {
          const response = await ConversationsAPI.put_BulkEdit_Mailbox(data)
          this.$messaging.showSuccess(response.message)
          submitSucceeded = true
        } catch (error) {
          this.$error.emit(error, true)
        }
      } else {
        const data = {
          listTaskIDs: this.selectedItemIds,
          newInternalProjectID: this.selectedEntityID,
          listStatusMappings: this.statusMappings,
        } as ITasksInputBulkEditInternalProject
        try {
          const response = await TasksAPI.put_BulkEdit_InternalProject(data)
          this.$messaging.showSuccess(response.message)
          submitSucceeded = true
        } catch (error) {
          this.$error.emit(error, true)
        }
      }
      this.isSubmitting = false
      // Do update...
      if (submitSucceeded) {
        this.$emit('edit-completed', this.selectedEntityID)
      }
    },
  },
})
